import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.core').service('registrationRequestSvc', registrationRequestSvc);

    registrationRequestSvc.$inject = ['$sessionStorage', 'registrationRequestDA'];

    /* @ngInject */
    function registrationRequestSvc($sessionStorage,registrationRequestDA) {
        var exports = {
            getRegistrationRequest: getRegistrationRequest,
            getRegistrationRequestList: getRegistrationRequestList,
            searchRegistrationCompanies:searchRegistrationCompanies,
            getRegistrationRequestExport:getRegistrationRequestExport,
        };

        return exports;

        /**
         * fournit les préinscriptions  .
         */
        function getRegistrationRequestList(registrationRequestFilter) {
            $sessionStorage.registrationRequestFilter = registrationRequestFilter ;
            var filter = registrationRequestFilter.prepareBeforeSearch();
            return registrationRequestDA.getRegistrationRequestList(filter);
            
        }

        /**
         * fournit les détails d'une préinscription.
         */
         function getRegistrationRequest(id) {
            return registrationRequestDA.getRegistrationRequest(id);
            
        }

        /**
         * fournit l'export des préinscriptions  en forma csv .
         */
        function getRegistrationRequestExport(registrationRequestFilter) {
            $sessionStorage.registrationRequestFilter = registrationRequestFilter;
            var filter = registrationRequestFilter.prepareBeforeSearch();
            return registrationRequestDA.getRegistrationRequestExport(filter)
        }

        /**
         * fournit les company  préinscris pour l'autocomplition.
         */
        function searchRegistrationCompanies(value){
            return registrationRequestDA.searchRegistrationCompanies(value);
        }      
        
    }
})();
